import { api } from '@/shared/lib/api'
import type {
  BackfillPreviewRequest,
  BackfillPreviewResponse,
  BackfillGrantRequest,
  BackfillGrantResponse,
  BenefitRule,
  BenefitRulePaginatedResponse,
} from '../types'

export const backfillService = {
  preview: async (payload: BackfillPreviewRequest): Promise<BackfillPreviewResponse> => {
    const { data } = await api.post('/benefits/backfill/preview', payload)
    return data
  },

  grant: async (payload: BackfillGrantRequest): Promise<BackfillGrantResponse> => {
    const { data } = await api.post('/benefits/backfill/grant', payload)
    return data
  },

  getRulesForCategory: async (category: string): Promise<BenefitRule[]> => {
    const { data } = await api.get<BenefitRulePaginatedResponse>('/benefit_rules/', {
      params: { page: 1, limit: 100, is_active: true },
    })
    return data.data.filter((rule) => {
      const eligible = (rule.rules_config?.eligible_categories as string[]) ?? []
      return eligible.map((c: string) => c.toLowerCase()).includes(category.toLowerCase())
    })
  },

  getClientCountByCategory: async (): Promise<Record<string, number>> => {
    const counts: Record<string, number> = {}
    const categories = ['bronce', 'marmol', 'oro']
    for (const cat of categories) {
      const { data } = await api.get('/clients/', {
        params: { page: 1, limit: 1, last_known_category: cat },
      })
      counts[cat] = data.total_items ?? 0
    }
    return counts
  },
}
